{
  "name": "admin-portal-ui",
  "version": "0.7.6",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-dev": "ng build --configuration dev",
    "build-demo": "ng build --configuration demo",
    "build-test": "ng build --configuration test",
    "build-test-covercat": "ng build --configuration test-covercat",
    "build-prod-covercat": "ng build --configuration prod-covercat",
    "watch": "ng build --watch --configuration dev",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.0.0",
    "@angular/cdk": "^19.0.0",
    "@angular/common": "^19.0.0",
    "@angular/compiler": "^19.0.0",
    "@angular/core": "^19.0.0",
    "@angular/forms": "^19.0.0",
    "@angular/material": "^19.0.0",
    "@angular/material-moment-adapter": "^19.0.0",
    "@angular/platform-browser": "^19.0.0",
    "@angular/platform-browser-dynamic": "^19.0.0",
    "@angular/router": "^19.0.0",
    "@azure/msal-angular": "^3.1.0",
    "@azure/msal-browser": "^3.27.0",
    "@fontsource/halant": "^4.5.8",
    "@fontsource/nunito-sans": "^4.5.8",
    "@fontsource/open-sans": "^4.5.10",
    "@fontsource/roboto": "^4.5.7",
    "@fontsource/source-sans-pro": "^4.5.10",
    "bootstrap": "^5.3.3",
    "country-locale-map": "^1.9.9",
    "esbuild": "^0.28.0",
    "heic2any": "^0.0.4",
    "libphonenumber-js": "^1.11.14",
    "material-design-icons": "^3.0.1",
    "moment": "^2.30.1",
    "rxjs": "~7.8.1",
    "tslib": "^2.3.0",
    "uuid": "^11.0.3",
    "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.1/xlsx-0.20.1.tgz",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.0",
    "@angular/cli": "^19.0.0",
    "@angular/compiler-cli": "^19.0.0",
    "@types/jasmine": "~5.1.4",
    "@types/node": "^24.2.0",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.5.2"
  }
}
